import { render, staticRenderFns } from "./Kh_nakladnoy.vue?vue&type=template&id=2aae2337&"
import script from "./Kh_nakladnoy.vue?vue&type=script&lang=js&"
export * from "./Kh_nakladnoy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports